const initialState = window.init_data;
const initList = (initialState && initialState[4] && initialState[4].list) || [];
export default function latestNews(state = initList, action) {
  return state || [];
}